import { render, staticRenderFns } from "./FooterArea.vue?vue&type=template&id=3fd3096a&scoped=true&"
import script from "./FooterArea.vue?vue&type=script&lang=js&"
export * from "./FooterArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd3096a",
  null
  
)

export default component.exports